import noop from 'lodash/noop';
import { createContext } from 'react';
import type { LoginParams, TwoFactorAuthParams } from '../api';

export interface AuthContextValue {
  isAuthorized: boolean;
  signIn(params: LoginParams): void;
  twoFactorAuth(params: TwoFactorAuthParams): void;
  signOut(): void;
}

export const AuthContext = createContext<AuthContextValue>({
  isAuthorized: false,
  signIn: noop,
  twoFactorAuth: noop,
  signOut: noop,
});
